import { PageHeader } from '../../app/PageHeader'
import copy from '../../demo/fixtures/copy.json'
import { QuotaMeter } from './QuotaMeter'
import styles from './PartnershipPage.module.css'
import { TierPicker } from './TierPicker'

export function PartnershipPage() {
  const page = copy.pages.partnership

  return (
    <>
      <PageHeader title={page.title} subtitle={page.subtitle} />
      <div className={styles.layout}>
        <div className={styles.tierColumn}><TierPicker /></div>
        <div className={styles.quotaColumn}><QuotaMeter /></div>
      </div>
    </>
  )
}
